// src/authConfig.js

import * as msal from "@azure/msal-browser";
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

export const msalConfig = {
  auth: {
    clientId: "a9435d31-63d7-43d2-aa87-ab5400c2c7c9",
    authority: "https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb",
    //redirectUri: "http://localhost:3000/amazonq/callback", // or your deployed URL
    redirectUri: "https://synopsfleet-qa.accenture.com/amazonq/callback"
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case msal.LogLevel.Error:
            console.error(message);
            return;
          case msal.LogLevel.Info:
            console.info(message);
            return;
          case msal.LogLevel.Verbose:
            console.debug(message);
            return;
          case msal.LogLevel.Warning:
            console.warn(message);
            break;
          default:
        }
      },
    },
    tokenRenewalOffsetSeconds: 900,
  },
};

// export const loginRequest = {
//   scopes: [
//     "api://c0d37cdb-496c-406c-a827-fe936a0816a3//read",
//     "api://c0d37cdb-496c-406c-a827-fe936a0816a3//write",
//   ]
// };

export const loginRequest = {
  scopes: [
    "api://d484dd73-9380-4c63-abbb-16d079592d94//read",
    "api://d484dd73-9380-4c63-abbb-16d079592d94//write",
  ]
};
